import { useMemo, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import {
  subtractPeriodValueBaseOnPreviousPeriod,
} from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetChangingDeferredTaxCalculation = () => {
  const { setValue, getValues } = useFormContext();
  const initialDeferredTax = useRef('0');

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [changingDeferredTaxField, initialDeferredTaxField] =
    observedFields.deferredTaxChanges.setCalculatedValueFieldNames;

  initialDeferredTax.current = getValues(initialDeferredTaxField);

  const getChangingDeferredTaxCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;
        const [deferredTaxAssets] = content;
        const changingDeferredTax = subtractPeriodValueBaseOnPreviousPeriod(
          deferredTaxAssets,
          initialDeferredTax.current,
        );

        setValue(changingDeferredTaxField, changingDeferredTax);
      }, 700),
    [],
  );

  return getChangingDeferredTaxCalculationHandler;
};
